import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FacebookIcon, InstagramIcon, LinkedinIcon, SendIcon, CheckIcon } from 'lucide-react';
import { Logo } from './shared/Logo';
const NAV = [{
  label: 'Početna',
  href: '#pocetna'
}, {
  label: 'O nama',
  href: '#o-nama'
}, {
  label: 'Usluge',
  href: '#usluge'
}, {
  label: 'Zašto mi',
  href: '#zasto-mi'
}, {
  label: 'Galerija',
  href: '#galerija'
}, {
  label: 'Česta pitanja',
  href: '#pitanja'
}, {
  label: 'Kontakt',
  href: '#kontakt'
}];
const socials = [{
  icon: FacebookIcon,
  label: 'Facebook',
  href: '#'
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  href: '#'
}, {
  icon: LinkedinIcon,
  label: 'LinkedIn',
  href: '#'
}];
function scrollTo(href: string) {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({
    behavior: 'smooth'
  });
}
export function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');
  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Unesite ispravnu email adresu.');
      return;
    }
    setError('');
    setSubscribed(true);
    setEmail('');
    setTimeout(() => setSubscribed(false), 5000);
  };
  return <footer className="relative w-full bg-ink text-white" data-id="element-107">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20" data-id="element-108">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12" data-id="element-109">
          {/* Brand */}
          <div className="lg:col-span-4" data-id="element-110">
            <Logo variant="lg" size={64} light data-id="element-111" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60" data-id="element-112">
              Agencija za posredovanje pri zapošljavanju njegovatelja i
              njegovateljica te organizaciju kućne njege. Povjerenje koje spaja
              ljude i kvalitetnu njegu.
            </p>
            <div className="mt-6 flex gap-3" data-id="element-113">
              {socials.map(s => <a key={s.label} href={s.href} aria-label={s.label} className="flex h-11 w-11 items-center justify-center rounded-full bg-white/5 text-white/80 transition-colors hover:bg-gold hover:text-white" data-id="element-114">
                  <s.icon className="h-5 w-5" data-id="element-115" />
                </a>)}
            </div>
          </div>

          {/* Nav */}
          <div className="lg:col-span-3" data-id="element-116">
            <h3 className="font-display text-lg font-semibold text-gold" data-id="element-117">
              Navigacija
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-118">
              {NAV.map(n => <li key={n.href} data-id="element-119">
                  <a href={n.href} onClick={e => {
                e.preventDefault();
                scrollTo(n.href);
              }} className="text-sm text-white/60 transition-colors hover:text-gold" data-id="element-120">
                    {n.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Newsletter */}
          <div className="lg:col-span-5" data-id="element-121">
            <h3 className="font-display text-lg font-semibold text-gold" data-id="element-122">
              Newsletter
            </h3>
            <p className="mt-5 text-sm text-white/60" data-id="element-123">
              Prijavite se za savjete o njezi i novosti iz Golden Care.
            </p>
            <form onSubmit={handleSubscribe} noValidate className="mt-5" data-id="element-124">
              <div className="flex flex-col gap-3 sm:flex-row" data-id="element-125">
                <input type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                if (error) setError('');
              }} placeholder="Vaša email adresa" aria-label="Email adresa za newsletter" className="flex-1 rounded-full border border-white/15 bg-white/5 px-5 py-3.5 text-sm text-white outline-none transition-colors placeholder:text-white/40 focus:border-gold" data-id="element-126" />
                <button type="submit" className="inline-flex items-center justify-center gap-2 rounded-full bg-gold-gradient px-6 py-3.5 text-sm font-semibold text-white shadow-gold transition-transform hover:scale-[1.03] active:scale-95" data-id="element-127">
                  {subscribed ? <CheckIcon className="h-4 w-4" data-id="element-128" /> : <SendIcon className="h-4 w-4" data-id="element-129" />}
                  {subscribed ? 'Prijavljeni' : 'Prijava'}
                </button>
              </div>
              {error && <p className="mt-2 text-sm text-red-400" data-id="element-130">{error}</p>}
              {subscribed && <p className="mt-2 text-sm text-gold-light" data-id="element-131">
                  Hvala na prijavi! Dobrodošli u Golden Care zajednicu.
                </p>}
            </form>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-132">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-5 py-6 text-sm text-white/50 sm:flex-row sm:px-8" data-id="element-133">
          <p data-id="element-134">© {new Date().getFullYear()} Golden Care. Sva prava zadržana.</p>
          <div className="flex gap-6" data-id="element-135">
            <a href="#" className="transition-colors hover:text-gold" data-id="element-136">
              Politika privatnosti
            </a>
            <a href="#" className="transition-colors hover:text-gold" data-id="element-137">
              Uslovi korištenja
            </a>
          </div>
        </div>
      </div>
    </footer>;
}